import Flickity from "flickity";

const carousel = document.querySelector(".js-carousel");

if (carousel) {
  new Flickity(carousel, {
    contain: true,
    adaptiveHeight: false,
    imagesLoaded: true,
    wrapAround: true
  });
}
